import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Modal,
  Spin,
  Checkbox,
} from "antd";

import "./nujobssignup.scss";
import nujobslogo from "../assets/landingFeatures/explorer.png";
import { actionsNuJobs } from "../actions";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";

export default function NuJobsSignup() {
  const [loader, SetLoader] = useState(false);
  const [formKey1, setFormKey1] = useState(1);
  const [currentView, setCurrentView] = useState("signup-1");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [inputData, setFormData] = useState({
    username: "",
    contact: "",
    email: "",
    permission: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
    planname: "",
    subscriptionperiod: "",
    trialperiod: "",
    amount: "",
    // Privacy / Terms acceptance
    termsaccepted: false,
    privacyaccepted: false,
    termsversion: "1.0",
    privacypolicyversion: "2026-09-13",
  });

  useEffect(() => {}, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCreateAccount = () => {
    // Validate mandatory fields
    const requiredFieldNames = ["username", "contact", "email"];

    const missingFields = requiredFieldNames.filter(
      (field) =>
        !inputData[field] ||
        inputData[field].trim() === ""
    );

    if (missingFields.length > 0) {
      setError(
        `Please provide mandatory data: ${missingFields.join(", ")}`
      );
      showModal();
      return;
    }

    // Validate Terms and Privacy Policy acceptance
    if (
      !inputData.termsaccepted ||
      !inputData.privacyaccepted
    ) {
      setError(
        "Please agree to the Terms of Use and acknowledge the Privacy Policy to create your NuJobs account."
      );
      showModal();
      return;
    }

    SetLoader(true);

    dispatch(
      actionsNuJobs.NuJobsSignup(
        inputData,
        (error, status) => {
          if (!error) {
            navigate("/nujobsotpprocess", {
              state: {
                reason: "verifyotp",
                trigger: "signup",
                signupemail: inputData.email,
              },
            });

            SetLoader(false);
          } else {
            SetLoader(false);

            console.error("API Error:", error);

            if (error === "decode error") {
              setError("Kindly fill right details.");
            } else if (error === "please sign in") {
              setError(
                "Account already created, kindly sign in."
              );
            } else if (error === "verification pending") {
              setError(
                "OTP Verification pending, Kindly verify your email id."
              );
            } else {
              setError(error);
            }

            showModal();

            console.log("status", status);
          }
        }
      )
    );
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData({
      ...inputData,
      [name]: value.trim(),
    });
  };


  const handleTermsChange = (event) => {
    const checked = event.target.checked;

    setFormData({
      ...inputData,
      termsaccepted: checked,
      privacyaccepted: checked,
    });
  };

  return (
    <div className="nuJobssignup-wrapper">
      <div className="nujobssignup-form-wrapper">

        <div className="signupnew-leftarea">
          <div className="nujobs-login-left-content">
            <Link to="/nujobs">
              <img
                src={nujobslogo}
                alt="Explorer"
                width="230"
                height="auto"
              />
            </Link>
                <div className="nujobs-login-branding">
                  <h2>Find the Right Job. From the Right Company.</h2>
                  <p>Multiple Companies.One Platform.</p>
                </div>             
          </div>
        </div>

        <div className="signupnew-rightarea">

          <div className="signupnew-heading">
            Sign Up to NuJobs <br />
          </div>

          <Form
            key={formKey1}
            className="profile-form"
            name="signon-form"
            justify="start"
            layout="vertical"
            autoComplete="off"
          >

            {currentView === "signup-1" ? (
              <>

                <Form.Item
                  required={true}
                  className="profile-field-item"
                  label="Your Name"
                  name="username"
                >
                  <Input
                    required={true}
                    className="profile-input-full"
                    onChange={handleChange}
                    name="username"
                    placeholder="Enter User Name"
                  />
                </Form.Item>

                <div className="prfile-form">

                  <Form.Item
                    required={true}
                    className="profile-field-item"
                    label="Mobile Number"
                    name="contact"
                  >
                    <Input
                      required={true}
                      className="profile-input-full"
                      onChange={handleChange}
                      name="contact"
                      placeholder="Enter Mobile Number"
                    />
                  </Form.Item>

                  <Form.Item
                    required={true}
                    className="profile-field-item"
                    label="Email ID"
                    name="email"
                    normalize={(value) =>
                      value.trim().toLowerCase()
                    }
                  >
                    <Input
                      required={true}
                      className="profile-input-full"
                      onChange={handleChange}
                      name="email"
                      placeholder="Enter Email ID"
                    />
                  </Form.Item>

                </div>

                {/* Terms and Privacy Acceptance */}
                <div
                  className="nujobs-signup-consent"
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    fontSize: "12px",
                  }}
                >

                  <Checkbox
                    checked={
                      inputData.termsaccepted &&
                      inputData.privacyaccepted
                    }
                    onChange={handleTermsChange}
                  >
                    I agree to the{" "}
                    <Link
                      to="/terms-conditions"
                      target="_blank"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Terms of Use
                    </Link>{" "}
                    and acknowledge the{" "}
                    <Link
                      to="/privacy-policy"
                      target="_blank"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Privacy Policy
                    </Link>
                    .
                  </Checkbox>

                  <div
                    style={{
                      marginTop: "8px",
                      marginLeft: "24px",
                      color: "#666",
                      lineHeight: "1.5",
                    }}
                  >
                    By creating an account, you understand that
                    NuJobs may process your profile and resume
                    information for job search, resume parsing,
                    job matching, recommendations, applications,
                    and other recruitment-related services. When
                    you apply for a job, relevant profile, resume,
                    and application information may be shared with
                    the employer or recruiter associated with that
                    job.
                  </div>

                </div>

                <div
                  className="profile-field-item"
                  style={{ marginTop: "15px" }}
                >
                  <Button
                    style={{
                      width: "100%",
                      height: "40px",
                      fontWeight: "600",
                    }}
                    type="primary"
                    htmlType="button"
                    onClick={handleCreateAccount}
                  >
                    {loader ? (
                      <Spin
                        indicator={
                          <LoadingOutlined
                            style={{ color: "white" }}
                            spin
                          />
                        }
                      />
                    ) : (
                      "Create Account Now"
                    )}
                  </Button>
                </div>

              </>
            ) : (
              <></>
            )}

          </Form>

          <Modal
            title="Signup"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            {error}
          </Modal>

          <div className="signupnew-links-wrapper"></div>

          <div className="signupnew-links-wrapper">

            <div className="signupnew-links">
              <Link
                to={"/nujobsotpprocess"}
                state={{
                  reason: "start",
                  trigger: "signin",
                }}
              >
                Sign In
              </Link>
            </div>

            <div className="signupnew-links">
              <Link
                to={"/nujobsotpprocess"}
                state={{
                  reason: "alreadygot",
                  trigger: "signup",
                }}
              >
                Got Valid OTP?
              </Link>
            </div>

            <div className="signupnew-links">
              <Link to="/nujobssignup">
                New Account Sign up
              </Link>
            </div>

          </div>
        </div>
      </div>

      <div className="otpprocess-footer">

        <div>
          <p>
            Nujobs is part of QuallyHire AI Product Family
            from HMW Communications Pvt. Ltd
          </p>
        </div>

        <div>
          <a>
            <p>
              Dont have an account ?{" "}
              <Link to={"/nujobssignup"}>
                Sign up Now!
              </Link>
            </p>
          </a>
        </div>
      </div>
    </div>
  );
}